module.exports = __webpack_public_path__ + "img/aztec_460.93de9c2d.png";